var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"camera outline\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6667 12.3448H26.6667V9.84477C26.6667 8.7397 26.2277 7.67989 25.4463 6.89849C24.6649 6.11709 23.6051 5.6781 22.5 5.6781H17.5C16.395 5.6781 15.3352 6.11709 14.5538 6.89849C13.7724 7.67989 13.3334 8.7397 13.3334 9.84477V12.3448H8.33337C7.00729 12.3448 5.73552 12.8716 4.79784 13.8092C3.86016 14.7469 3.33337 16.0187 3.33337 17.3448V30.6781C3.33337 32.0042 3.86016 33.276 4.79784 34.2136C5.73552 35.1513 7.00729 35.6781 8.33337 35.6781H31.6667C32.9928 35.6781 34.2646 35.1513 35.2022 34.2136C36.1399 33.276 36.6667 32.0042 36.6667 30.6781V17.3448C36.6667 16.0187 36.1399 14.7469 35.2022 13.8092C34.2646 12.8716 32.9928 12.3448 31.6667 12.3448ZM16.6667 9.84477C16.6667 9.62375 16.7545 9.41179 16.9108 9.25551C17.0671 9.09923 17.279 9.01143 17.5 9.01143H22.5C22.7211 9.01143 22.933 9.09923 23.0893 9.25551C23.2456 9.41179 23.3334 9.62375 23.3334 9.84477V12.3448H16.6667V9.84477ZM33.3334 30.6781C33.3334 31.1201 33.1578 31.5441 32.8452 31.8566C32.5327 32.1692 32.1087 32.3448 31.6667 32.3448H8.33337C7.89135 32.3448 7.46742 32.1692 7.15486 31.8566C6.8423 31.5441 6.66671 31.1201 6.66671 30.6781V17.3448C6.66671 16.9027 6.8423 16.4788 7.15486 16.1663C7.46742 15.8537 7.89135 15.6781 8.33337 15.6781H31.6667C32.1087 15.6781 32.5327 15.8537 32.8452 16.1663C33.1578 16.4788 33.3334 16.9027 33.3334 17.3448V30.6781Z",
    fill: "#012E40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat2);
export default __webpack_public_path__ + "static/media/cat2.48f8e406f6ae0ab34cbc9156fe822612.svg";
export { ForwardRef as ReactComponent };